import React from "react";

function Settlements(props) {
  const myLists = props.settlementJson;
  const listItems = myLists.map((myList) => (
    <li key={myList.id} className="Array-item">
      <div className="title">
        {myList.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال
      </div>
      <div className="date">{myList.approved_at_fa}</div>
      <div className="describe">
        <b>وضعیت:</b> {myList.status_text}
      </div>
    </li>
  ));
  return (
    <div className="w-100 body-padding px-2">
      <p className="wp-header">درخواست های تسویه حساب</p>
      <ul className="Array">
        {listItems.length === 0 ? (
          <li className="Array-item">
            <div className="title">هنوز درخواستی توسط شما ثبت نشده است.</div>
          </li>
        ) : (
          listItems
        )}
      </ul>
    </div>
  );
}

export default Settlements;
